export default __webpack_public_path__ + "static/media/bg-sm.66763cd2.svg";